import { render, staticRenderFns } from "./TreasurySettings.vue?vue&type=template&id=849d75b2&scoped=true&"
import script from "./TreasurySettings.vue?vue&type=script&lang=js&"
export * from "./TreasurySettings.vue?vue&type=script&lang=js&"
import style0 from "./TreasurySettings.vue?vue&type=style&index=0&id=849d75b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849d75b2",
  null
  
)

export default component.exports